import defaultTheme from 'tailwindcss/defaultTheme';

const getScreens = () => defaultTheme.screens;

export const screenIs = (mediaQuery) => {
    const screenSizePX = getScreens()[mediaQuery] ?? null;
    if(!screenSizePX) return false;

    const screenSize = Number(screenSizePX.replace('px', ''));

    return window.innerWidth > screenSize;
}

export const screenUtilsMixin = {
    methods: {
        screenIs: screenIs,
    }
}
